import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faMountain, 
  faFlask, 
  faBolt, 
  faDumbbell 
} from '@fortawesome/free-solid-svg-icons';

const ShilajitSection: React.FC = () => {
  const features = [
    {
      icon: faMountain,
      title: 'Raw Himalayan Resin',
      description: 'Naturally oozes from rocks in the high Himalayas pressure-formed over centuries by plant matter and minerals.'
    },
    {
      icon: faFlask,
      title: 'Concentrated Power',
      description: 'Packed with fulvic acid and over 85 trace minerals one of nature’s most potent mineral sources.'
    },
    {
      icon: faBolt,
      title: 'Pure Energy',
      description: 'Traditionally valued in natural wellness, this pure resin is crafted to maintain its authentic form and may help support your body’s natural energy as part of a balanced lifestyle.'
    },
    {
      icon: faDumbbell,
      title: 'Strength & Recovery',
      description: 'This natural resin has been traditionally valued for supporting daily vitality and endurance. Carefully harvested and preserved without additives or dilution, it maintains its authentic composition to complement your wellness '
    }
  ];

  return (
    <section className="py-16 md:py-24 bg-gradient-to-br from-[#2b603e]/5 to-[#2b603e]/10">
      <div className="container mx-auto px-4">
        <div className="grid lg:grid-cols-2 gap-8 md:gap-16 items-center">
          <div className="relative order-2 lg:order-1">
            <img 
              src={require('../assets/images/mels-shilajit-product.png')} 
              alt="Shilajit Product" 
              className="w-full h-auto object-contain floating" 
            />
          </div>

          <div className="space-y-8 order-1 lg:order-2">
            <div className="inline-block">
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mt-2 bg-clip-text text-transparent bg-gradient-to-r from-[#2b603e] to-[#1a3d25]">
                What is Shilajit?
              </h2>
            </div>

            <div className="space-y-6 text-lg text-gray-700 leading-relaxed">
              <p>
                Deep within the ancient Himalayan mountains, over centuries, nature’s pressure transforms plant matter and minerals into Shilajit a rare, potent resin rich in trace elements and fulvic acid. A true gift of the earth, crafted by time and elemental force.
              </p>

              <h3 className="text-xl font-semibold text-[#2b603e] mt-4">What can Shilajit do for you?</h3>
              <p>
                Brimming with essential minerals, Shilajit is a natural ally in supporting your daily nutrition and fostering harmony between body, mind, and spirit. It’s not a cure it’s nature’s call to balance and vitality.
              </p>

              <h3 className="text-xl font-semibold text-[#2b603e] mt-4">Asclepius delivers pure, raw Shilajit</h3>
              <p>
                At Asclepius, we honor this ancient gift by offering Shilajit in its purest, untouched form. No dilution, no additives just the raw, unfiltered power of the mountains, selected with care and delivered directly to you.
              </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
              {features.map((feature, index) => (
                <div 
                  key={index} 
                  className="bg-white p-6 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 flex flex-col"
                >
                  <div className="flex items-center justify-center mb-1">
                    <div className="w-10 h-10 bg-[#2b603e]/10 rounded-lg flex items-center justify-center mr-4">
                      <FontAwesomeIcon 
                        icon={feature.icon} 
                        className="text-[#2b603e] text-lg" 
                      />
                    </div>
                    <h3 className="text-xl font-bold text-gray-800">
                      {feature.title}
                    </h3>
                  </div>
                  <p className="text-gray-600 text-center">
                    {feature.description}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ShilajitSection;
